import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * FilterSection Component
 * Collapsible section that groups related filters (e.g., "Company", "Role", "Personal")
 */
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { Box, Chip, Collapse, IconButton, Typography } from "@mui/material";
import { useState } from "react";
export const FilterSection = ({ title, activeCount = 0, defaultExpanded = false, children, }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    return (_jsxs(Box, Object.assign({ sx: { mb: 2 } }, { children: [_jsxs(Box, Object.assign({ onClick: () => setExpanded(!expanded), sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    py: 1,
                    cursor: "pointer",
                    "&:hover": {
                        opacity: 0.8,
                    },
                } }, { children: [_jsx(Typography, Object.assign({ variant: "caption", sx: {
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            color: "text.secondary",
                        } }, { children: title })), activeCount > 0 && (_jsx(Chip, { size: "small", label: activeCount, color: "primary", sx: {
                            height: 18,
                            fontSize: "10px",
                            fontWeight: 600,
                            "& .MuiChip-label": {
                                px: 1,
                            },
                        } })), _jsx(Box, { sx: { flex: 1 } }), _jsx(IconButton, Object.assign({ size: "small", sx: {
                            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s",
                            p: 0.5,
                        } }, { children: _jsx(ExpandMoreIcon, { fontSize: "small" }) }))] })), _jsx(Collapse, Object.assign({ in: expanded }, { children: _jsx(Box, Object.assign({ sx: {
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        overflow: "hidden",
                    } }, { children: children })) }))] })));
};
export default FilterSection;
